import { useDisplayField } from "../../hooks/useDisplayField";

export const filterCommercialCategory = ({ domain, filterValue, isInclude, isAdminPerson }: { domain: string, filterValue: string, isInclude: boolean, isAdminPerson: boolean }) => {

    const { getFilterOptions } = useDisplayField([]);
    const options = getFilterOptions(domain);

    if (isAdminPerson) {
        return options;
    }

    if (isInclude) {
        return options.filter((option) => option.key === filterValue);
    } else {
        return options.filter((option) => option.key !== filterValue);
    };

};